import script from "./TTextElement.vue?vue&type=script&lang=js"
export * from "./TTextElement.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__